module.exports = __webpack_public_path__ + "img/loading-4.551bf697.gif";